<div *ngIf="!isLinkButton" class="{{className}}" (click)="onClick()"> 
  <div class="itb-pulse"></div>
  <div class="itb-progress-circle" [attr.data-progress]="progressButton.progressBarValue">
    <div class="itb-circle">
      <div class="full itb-progress-circle__slice">
        <div class="itb-progress-circle__fill"></div>
      </div>
      <div class="itb-progress-circle__slice">
        <div class="itb-progress-circle__fill"></div>
        <div class="itb-progress-circle__fill itb-progress-circle__bar"></div>
      </div>
    </div>
    <div class="itb-progress-circle__overlay">
      <itb-icon [className]="progressButton.iconClassName"></itb-icon>
    </div>
  </div>
</div>

<a *ngIf="isLinkButton" class="{{className}}" routerLink="{{link}}"> 
    <div class="itb-pulse"></div>
    <div class="itb-progress-circle" [attr.data-progress]="progressButton.progressBarValue">
      <div class="itb-circle">
        <div class="full itb-progress-circle__slice">
          <div class="itb-progress-circle__fill"></div>
        </div>
        <div class="itb-progress-circle__slice">
          <div class="itb-progress-circle__fill"></div>
          <div class="itb-progress-circle__fill itb-progress-circle__bar"></div>
        </div>
      </div>
      <div class="itb-progress-circle__overlay">
        <itb-icon [className]="progressButton.iconClassName"></itb-icon>
      </div>
    </div>
</a>